import React, { useMemo } from 'react';

export default function EstadisticasProductoresTop({ stros, pas, activeProductor, onSelectProductor }) {
  // Map producer codes to their names
  const pasMap = useMemo(() => {
    const map = {};
    if (pas && Array.isArray(pas)) {
      pas.forEach(p => {
        // If it's the raw API object: { pro_productor: 1024, pro_raz_social: '...' }
        if (p.pro_productor !== undefined) {
          map[Number(p.pro_productor)] = p.pro_raz_social;
        } else if (p.value !== undefined) {
          // If it's already mapped: { value: 1024, label: '...' }
          // The label might be "1024 - Name", so we extract the name part if possible
          const parts = p.label.split(' - ');
          map[Number(p.value)] = parts.length > 1 ? parts.slice(1).join(' - ') : p.label;
        }
      });
    }
    return map;
  }, [pas]);

  // Aggregate claims by producer (codp)
  const ranking = useMemo(() => {
    if (!stros || stros.length === 0) return [];

    const counts = {};
    stros.forEach(s => {
      if (s.codp !== undefined && s.codp !== null) {
        const code = Number(s.codp);
        counts[code] = (counts[code] || 0) + 1;
      }
    });

    return Object.entries(counts)
      .map(([code, count]) => {
        const numCode = Number(code);
        return {
          code: numCode,
          name: pasMap[numCode] || 'Productor Desconocido',
          count,
        };
      })
      .sort((a, b) => b.count - a.count)
      .slice(0, 10); // Top 10 producers
  }, [stros, pasMap]);

  const maxCount = useMemo(() => {
    if (ranking.length === 0) return 1;
    return Math.max(...ranking.map(r => r.count));
  }, [ranking]);

  if (!stros || stros.length === 0) {
    return (
      <div className="est-card">
        <div className="est-card-header">
          <span className="est-card-title">
            <i className="bi bi-award-fill"></i>
            Ranking de Productores (Top 10)
          </span>
        </div>
        <div className="est-empty">
          <i className="bi bi-inbox"></i>
          <p>No hay datos de siniestros</p>
        </div>
      </div>
    );
  }

  return (
    <div className="est-card">
      <div className="est-card-header">
        <span className="est-card-title">
          <i className="bi bi-award-fill"></i>
          Ranking de Productores (Top 10)
        </span>
        {activeProductor && (
          <button
            className="btn btn-xs btn-outline-secondary"
            style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '12px' }}
            onClick={() => onSelectProductor(null)}
          >
            Limpiar filtro
          </button>
        )}
      </div>

      <div className="est-table-wrapper">
        <table className="est-table">
          <thead>
            <tr>
              <th>Productor</th>
              <th style={{ textAlign: 'right' }}>Siniestros</th>
            </tr>
          </thead>
          <tbody>
            {ranking.map((prod) => {
              const isSelected = activeProductor === prod.code;
              const barWidth = (prod.count / maxCount) * 100;
              const initials = prod.name.substring(0, 2).toUpperCase();

              return (
                <tr
                  key={prod.code}
                  className={`monitoreo-row ${isSelected ? 'monitoreo-row--selected' : ''}`}
                  onClick={() => onSelectProductor(prod.code === activeProductor ? null : prod.code)}
                  style={{ cursor: 'pointer' }}
                >
                  <td>
                    <div className="est-prod-cell">
                      <div className="est-prod-avatar">
                        {initials}
                      </div>
                      <div className="est-prod-info">
                        <span className="est-prod-name">{prod.name}</span>
                        <span className="est-prod-code">Cód. {prod.code}</span>
                      </div>
                    </div>
                  </td>
                  <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                      <span className="est-bar-count">{prod.count}</span>
                      <div style={{ width: '60px', height: '4px', backgroundColor: '#f1f5f9', borderRadius: '2px', overflow: 'hidden' }}>
                        <div
                          style={{
                            width: `${barWidth}%`,
                            height: '100%',
                            backgroundColor: '#42C3BA',
                            borderRadius: '2px',
                          }}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
